import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesCategories } from "./../../constants";

export const requestGetParentCategories = async <T>(
  id: string
): Promise<T[]> => {
  return await instance.get(buildUrl(ApiRoutesCategories.ChildCategories, id));
};
